export function _basicAssign(target, source) {
    var prop;
    for (prop in source) {
        if (Object.prototype.hasOwnProperty.call(source, prop)) {
            target[prop] = source[prop];
        }
    }
    return target;
}
export function _getProperty(source, prop) {
    return _isArray(source) ? source[Number(prop)] : source[prop];
}
export function _getByPath(source, path) {
    if (!source) {
        return undefined;
    }
    var prop = path.shift();
    var value = _getProperty(source, prop);
    if (path.length && (_isArray(value) || _isRecord(value))) {
        return _getByPath(value, path);
    }
    return value;
}
export function _isArray(value) {
    return Array.isArray(value);
}
export function _isRecord(value) {
    return value && typeof value === 'object';
}
export function _setProperty(target, prop, value) {
    if (_isArray(target)) {
        target[Number(prop)] = value;
        return;
    }
    if (_isRecord(target)) {
        target[prop] = value;
        return;
    }
    throw new Error('shallowClone: target must be an object or an array');
}
export function _shallowClone(source) {
    if (_isArray(source))
        return source.slice(0);
    if (_isRecord(source))
        return _basicAssign({}, source);
    throw new Error('shallowClone: source must be an object or an array');
}
